import { DatePipe } from '@angular/common';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CreateReadMessageSingleResponse, StoreReadMessageRequest, Thread } from '@lib/api/models/message';
import { getDisplayName } from '@lib/api/models/person';
import { AuthenticationService } from '@lib/auth/authentication.service';
import { User } from '@lib/api/models/user';
import { MessageService } from '@lib/messages/message.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';

@Component({
    selector: 'app-thread-inbox-message',
    imports: [DatePipe, ComponentsModule],
    templateUrl: './thread-inbox.component.html',
    standalone: true,
    styleUrl: './thread-inbox.component.scss'
})

export class ThreadInboxComponent {
    @Input() thread: Thread | undefined;
    @Input() selectedThreadId: string | null = null;
    @Input() userId: string | null = null;
    @Output() threadClick = new EventEmitter<Thread>();
    @Output() checkboxChanged = new EventEmitter<{ id: string, checked: boolean }>();

    @Input() selected = false;


    private readonly _messageService = inject(MessageService)

    protected readonly getDisplayName = getDisplayName;
    threadSelected = '';
    selectedThreadIds: string[] = []

    protected user: User | null = null;

    readMessage = new SendableRequest<CreateReadMessageSingleResponse, StoreReadMessageRequest>({
        request: (payload) => this._messageService.readMessage(payload!),

        onError: () => {
          console.error('Error reading message');
        }
      });

    constructor(private _authService: AuthenticationService) {
      this._authService.user$.subscribe(user => {
        this.user = user;
      });
    }

    handleClick() {
        if (this.thread) {
            this.threadClick.emit(this.thread);
            this.threadSelected = this.thread.id;

            this.thread.participants.forEach(participant => {
                if (participant.user_id === this.user?.id && !participant.read) {
                    participant.read = true;
                    this.readMessage.send({id: participant.id, read: true});
                }
            });
        }
    }

    onCheckboxChanged(event: Event) {
      if (!this.thread) {
        return;
      }
      this.checkboxChanged.emit({ id: this.thread!.id, checked: (event.target as HTMLInputElement).checked });
    }

    get lastMessage() {
        return this.thread?.messages?.at(-1) || null;
    }
}
